(function () {
    'use strict';

/**
 * @ngdoc service
 * @name FeatureManagerService
 *
 * @description
 * Service used for obtaining the list of features enabled for a particular user.
 */
    angular.module('GorillaBoy.FeatureManager')
    .service('FeatureManagerService', [
        '$http',
        '$log',
        '$q',
        'authenticatedUser',
        'EndpointService',
        'EndpointConfig',
        'Features',
        '$rootScope',
        'AppConstants',
        'OrganizationService',
        'ClientMetricsService',
        function ($http, $log, $q, authenticatedUser, EndpointService, EndpointConfig, Features, $rootScope, AppConstants, OrganizationService, ClientMetricsService) {
            var self = this,
                isPreviewSite = EndpointConfig.isPreviewSite(),
                enabledFeatureMapPendingPromise = null,
                enabledFeatureMap = null;

            self.initialized = false;

            function serviceRoot () {
                return EndpointService.endpoint() + 'user/';
            }

            function getEnabledFeatures (userId) {
                var config = {
                    // TODO: Angular's built-in cache doesn't support setting a TTL. We could use a third party add-on to achieve this in the future.
                    method: 'GET',
                    url: serviceRoot() + encodeURIComponent(userId) + '/features',
                    cache: true,
                };
                return $http(EndpointService.tokenize(config));
            }

            /**
             * Returns a promise that's always resolved after the feature deatils are fetched and stored in the rootScope
             */
            self.geO365FeatureDetails = function() {
                if (self.isFeatureEnabled(Features.DocumentViewer.O365)) {
                    //Only call the organization service if the O365 feature is enabled.
                    return $q(function(resolve, reject) {
                        OrganizationService.getFeatureDetails(AppConstants.ORG_FEATURES.O365).then(function(data) {
                            if (!angular.equals(data, {})) {
                                $rootScope.office365EditingEnabled = data.Enabled;
                            }
                            resolve({});
                        }, resolve);
                    });
                }
                return $q.when({}); //return an immediately resolved promise
            };

            $rootScope.isContentSearchEnabled = true;
            self.getContentSearchFeatureDetails = function() {
                return $q(function(resolve, reject) {
                    OrganizationService.getFeatureDetails(AppConstants.ORG_FEATURES.INDEX_CONTENT_FOR_SEARCH).then(function(data) {
                        if (!angular.equals(data, {})) {
                            $rootScope.isContentSearchEnabled = data.Enabled;
                        }
                        resolve({});
                    }, resolve);
                });
            };

            /**
             * Fetches the list of features enabled for a particular user and returns a promise
             * object with the map of enabled features.
             * Also sets self.initialized to true if the features promise is resolved.
             */
            self.getEnabledFeatureMap = function () {
                function resolveWithError(err) {
                    // getEnabledFeatureMap will always resolve, when error occurred, it resolve with empty map
                    ClientMetricsService.addLogsToSession({
                        event: 'GET_FEATURE_MAP_ERROR',
                        metadata : err
                    });
                    $log.error(err);
                    features.resolve({});
                }

                // We create a promise where we return an empty features map if the userId is not yet available or
                // the service API call fails, and we resolve it when we populate the feature map.
                var features = $q.defer(),
                    userInfo = authenticatedUser.getUserInfo();

                self.initialized = true;
                //If multiple callers call getEnabledFeatureMap() (from a resolveForView(), for example) then only make the
                //API call once
                if (enabledFeatureMapPendingPromise) {
                    return enabledFeatureMapPendingPromise.then(function() {
                        return enabledFeatureMap || {};
                    });
                } else if (enabledFeatureMap) {
                    // Resolves the promise with enabledFeatureMap if it already exists.
                    // This is a naive implementation - there could already be a call to this function
                    // that could eventually populate enabledFeatureMap, possibly causing redundant API calls.
                    features.resolve(enabledFeatureMap);
                } else if (!userInfo) {
                    // We make an attempt to get the userId, but log the response and return an empty featureMap if it is unavailable.
                    resolveWithError('userInfo is not available yet.');
                } else {
                    // If enabledFeatureMap is not set, then we make the API call.
                    enabledFeatureMapPendingPromise = getEnabledFeatures(userInfo.Id).then(function successFn(response) {
                        // Get the list of Feature objects
                        var featureObjects = response.data.Features;

                        if (featureObjects && featureObjects.length !== 0) {
                            var numFeatures = featureObjects.length;
                            enabledFeatureMap = {};
                            for (var i = 0; i < numFeatures; i++) {
                                // Populate the feature map
                                enabledFeatureMap[featureObjects[i].Name] = true;
                            }

                            var deferred = [];
                            deferred.push(self.geO365FeatureDetails());
                            deferred.push(self.getContentSearchFeatureDetails());

                            return $q.all(deferred).then(function() {
                                features.resolve(enabledFeatureMap);
                                return enabledFeatureMap;
                            });
                        } else {
                            resolveWithError('API failed to return the enabled features. The response is: ' + JSON.stringify(response));
                        }
                    }, resolveWithError);

                    enabledFeatureMapPendingPromise.finally(function() {
                        enabledFeatureMapPendingPromise = null;
                    });
                }
                return features.promise;
            };

            self.getAnonymousFeatureMap = function () {
                enabledFeatureMap = {};
                self.initialized = true;

                //For anonymous users, allow previewing audio/video content
                enabledFeatureMap[Features.DocumentViewer.NativeRendering] = true;
                return enabledFeatureMap;
            };

            self.isFeatureEnabled = $rootScope.isFeatureEnabled = function (featureName) {
                var isEnabled = false;

                // If the feature manager is not initialized, return false as a default.
                if (!self.initialized) {
                    return isEnabled;
                }

                // if the call to getFeatures returned no enabled features then return false
                if(!enabledFeatureMap) {
                    return isEnabled;
                }

                // if the requested feature is present then update the return value from the hashmap
                if (enabledFeatureMap.hasOwnProperty(featureName)) {
                    isEnabled = enabledFeatureMap[featureName];
                }

                // Respect the special flag on feature name that sets the feature on or off
                if (enabledFeatureMap.hasOwnProperty(featureName + '.On')) {
                    isEnabled = true;
                } else if (enabledFeatureMap.hasOwnProperty(featureName + '.Off')) {
                    isEnabled = false;
                }

                // If the user is in Preview site, check if there's a flag with ".BetaOn/Off suffix" and if Yes, that overrides the regular flag
                if (isPreviewSite) {
                    if (enabledFeatureMap.hasOwnProperty(featureName + '.BetaOn')) {
                        isEnabled = true;
                    } else if (enabledFeatureMap.hasOwnProperty(featureName + '.BetaOff')) {
                        isEnabled = false;
                    }
                }

                return isEnabled;
            };
        }
    ]);
}());
